import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "@src/lib/router";
// import Lottie from "react-lottie";
import { CONTENT_LIMIT } from "../../Content/store/constants";
import { installmentsAlertStateEnum } from "@src/components/Tabs/Overview/store/constants.js";
import { getCourseDetailsAction } from "@src/components/Tabs/Overview/store/actions";
import { getCourseContentAction, showNotesModalAction } from "../../Content/store/actions";
import MultipleValidityModal from "./MultipleValidity/MultipleValidityModal";
import MultipleValidity from "./MultipleValidity/index.js";
import Bundle from "./Bundle";
import FingerPointerGif from "./finger-pointer.json";
import StandAlone from "./StandAlone";
import MoneyBackClaimCard from "@src/components/Tabs/Content/components/MoneyBackGuarantee/MoneyBackClaimCard";
import PostPurchageIdfys from "./idfys/postpurchageIdfys/PostPurchageIdfys";
import SuccessIdfyDoc from "./idfys/postpurchageIdfys/SuccessIdfyDoc.jsx";
import 'intersection-observer';
import fingerPointerGif from "@src/assets/fingerpointer.gif";
import OverView from "./OverviewContent/OverView";
import AboutCourse from "./AboutCourse/AboutCourse";
import ChatComponent from "./ChatComponent/index.js";
import Coupons from "./Coupons/index";
import OverviewShimmmer from "./OverviewShimmer";
import FreeContent from "@src/components/Tabs/Content/components/FreeContent/FreeContentOverview";
import UpcomingLive from "./UpcomingLive";
import PricingSection from "./PricingSection";
import DashBorder from "../../../UIElements/DashBorder";
import OverviewAlertBox from "./OverviewAlertBox";
import MoneyBackGuarantee from "@src/components/Tabs/Content/components/MoneyBackGuarantee";
import MoneyBackBottomDrawer from "@src/components/Tabs/Content/components/MoneyBackGuarantee/MoneyBackBottomDrawer";
const OverViewPage = ({
  overviewServerData,
  getCourseCouponListStudentDataServer,
  isFirstMount,
}) => {
  const router = useRouter();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessDoc, setIsSuccessDoc] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const value = localStorage.getItem("idfySuccessDoc");
      if(value == 'true') {
        setIsSuccessDoc(value === "true");
      }
    }
  }, []);

  const state = useSelector((state) => state?.overviewReducer);

  const pricingDetails = useSelector(
    (state) => state?.overviewReducer?.graphCourseData?.coupons?.[0]
  );
  const contentListLength = useSelector(
    (state) => state?.courseContentReducer?.apiResGET_COURSE_CONTENT?.length
  );
  const isPullToRefreshTriggered = useSelector(
    (state) => state?.pullToRefreshReducer?.isPullToRefreshTriggered
  );

  const multipleCouponsConditions = useSelector(
    (state) => state?.overviewReducer?.multipleCouponsConditions
  );

  const showNotesModal = useSelector(
    (state) => state?.courseContentReducer?.showNotesModal
  );
  const autopayConfigId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.autopayConfig?.id || null
  );

  const isPriceDetailsNewHidden = pricingDetails?.isPriceDetailsNewHidden;

  const refresh = (showShimmer = true) => {
    dispatch(
      getCourseDetailsAction({
        courseId: router?.query?.courseId,
        isLoading: false,
        isPullToRefreshAction: isPullToRefreshTriggered,
        showPaymentLoader: pricingDetails ? false : true,
        autopayConfigId: autopayConfigId || null,

        ...(showShimmer
          ? {
              showForcefulShimmer: true,
            }
          : null),
      })
    );
  };

  // const isInitialMount = useRef(true);
  useEffect(() => {
    // To prevent multiple api calls
    // if (isInitialMount.current) {
    // isInitialMount.current = false;
    // } else {
    if(showNotesModal){
      dispatch(showNotesModalAction(false));
    }
    if (router?.query?.courseId && router?.query?.tabId == 1 && !isFirstMount) {
      if (!state?.overViewDetails?.course?.details?.name) {
        // console.log("LLLLL");
        dispatch(
          getCourseDetailsAction({
            courseId: router?.query?.courseId,
            isLoading: false,
            isPullToRefreshAction: isPullToRefreshTriggered,
            autopayConfigId: autopayConfigId || null,
            // showPaymentLoader: pricingDetails ? false : true,
            showPaymentLoader: !state?.graphCourseData?.priceBottom?.val,
          })
        );
      }
    }
    if (!contentListLength) {
      if (router.query.courseId) {
        dispatch(
          getCourseContentAction({
            courseId: router.query.courseId,
            limit: CONTENT_LIMIT,
            folderId: 0,
            skipLoader: true,
          })
        );
      }
    }
    // }
  }, [router?.query?.tabId]);

  useEffect(() => {
    if (isPullToRefreshTriggered) {
      refresh(false);
      // dispatch(
      //   getCourseDetailsAction({
      //     courseId: router?.query?.courseId,
      //     isLoading: false,
      //     isPullToRefreshAction: isPullToRefreshTriggered,
      //     showPaymentLoader: pricingDetails ? false : true,
      //   })
      // );
    }
  }, [isPullToRefreshTriggered]);

  const dispatch = useDispatch();

  const showCouponsEverywhere = useSelector(
    (state) => state?.overviewReducer?.showCouponsEverywhere
  );

  const paymentProcessingBox = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.paymentStatusEmblem
  );
  const isStandAlone = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.doubtBuddyCourseFlag) || false;

  const showForcefulShimmer = useSelector(
    (state) => state?.overviewReducer?.showForcefulShimmer
  );

  const multipleValiditySelected = useSelector(
    (state) => state.overviewReducer.multipleValiditySelected
  );

  const multipleValidityData = useSelector(
    (state) => state.overviewReducer.multipleValidity
  );

  const isPurchased = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased
  );
    const isFreeCourse = useSelector(
      (state) =>
        state?.overviewReducer?.overViewDetails?.course?.metaData?.isFreeCourse
    ) || 0;
  const bundleData = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundles
  );
  const courseMetaData = useSelector((state) => 
    state?.overviewReducer?.overViewDetails?.course?.metaData);
  const moneyBack = useSelector((state) => 
    state?.overviewReducer?.moneyBackGuarantee);
  
  const {
    addOnOptionId,
    prePurchasePopUpEnabled,
    prePurchaseAddOnAmount,
    isRemoveButtonEnable} = moneyBack;
  const isMoneyBackClaimCard = courseMetaData?.addOnData?.postPurchaseMoneyBackPopUpEnabled;
  const genericData = courseMetaData?.addOnData?.addOnTexts;
  const showAnimation = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.upcomingLiveClasses?.showAnimation
  );
  
  const isMultipleLiveClassEnabled = useSelector(
    (state) =>
      state?.persistedDataReducer?.orgDetails?.organization?.isMultipleLiveClassEnabled
  );
  const orgId = useSelector(
    (state) => state?.persistedDataReducer?.orgDetails?.organization?.id
  );

  const [isModalOpenNew, setIsModalOpenNew] = useState(false);
  const targetRef = useRef();
  const checkClassAnimationLocal = useMemo(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('showMultipleLiveClassAnimation') === "false";
    }
    return false;
  }, [isModalOpenNew]);

  const firstCallObserver = useRef(true);  

  const animationCheck = useMemo(() => {
    return isMultipleLiveClassEnabled && (!checkClassAnimationLocal && showAnimation);
  }, [isMultipleLiveClassEnabled, checkClassAnimationLocal, showAnimation]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (firstCallObserver.current) {
            firstCallObserver.current = false;
          } else if (entry.isIntersecting) {
            setIsModalOpenNew(true);
          }
        });
      },
      { threshold: 1 }
    );

    const currentTarget = targetRef.current;

    if (currentTarget && animationCheck) {
      observer.observe(currentTarget);
    }

    return () => {
      if (currentTarget && animationCheck) {
        observer.unobserve(currentTarget);
      }
      firstCallObserver.current = true;
    };
  }, [targetRef.current, animationCheck]);


  const showAnimationHandler = () => {
    setIsModalOpenNew(false);
    if (typeof window !== 'undefined') {
      localStorage.setItem('showMultipleLiveClassAnimation', "false");
    }
  };

  return (
    <>
    {courseMetaData?.verificationDetails?.postPurchase?.isVerificationRequired ? <PostPurchageIdfys postPurchageDetails={courseMetaData?.verificationDetails?.postPurchase} /> : null}
    {courseMetaData?.verificationDetails?.postPurchase?.isVerificationComplete && isSuccessDoc ? <SuccessIdfyDoc setIsSuccessDoc={setIsSuccessDoc} /> : null }
      {isModalOpen && (
        <MultipleValidityModal
          onClose={() => setIsModalOpen(false)}
          data={multipleValidityData}
        />
      )}

      {isModalOpenNew && (
        <div className="modalStyle">
          <div className="modalContentStyle">
            <div className="modalContentBody">
              {isModalOpenNew && (
                <div className="">
                  <img
                    src={fingerPointerGif}
                    alt="fingerpointer animation"
                    className="fingerPointer"
                  />
                </div>
              )}

              <UpcomingLive
                heading="Live Classes"
                headingColor="#fff"
                viewAllText="View Full Schedule"
                viewAllTextColor="#fff"
                overViewHeadingBackgroundColor="#021927"
                backgroundColor="#021927"
                subText="Join live trial classes to learn more about the course"
                subTextColor="#fff"
                dotClasses="UpcomingLive__Body__Dots slick-dots"
                zIndex={"8"}
              />

              {isModalOpenNew && (
                <div className="LiveClassTutorialText">
                  <span>Swipe Right to join other</span>
                  <span>Live Classes</span>
                  <button
                    className="GotItBtn"
                    onClick={() => showAnimationHandler()}
                  >
                    Got It
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="OverviewWrapper" style={{display:isStandAlone ? "block" : "grid"}}>
        {router?.isFallback ||
        showForcefulShimmer ||
        (state?.overViewDetailsLoading &&
          !overviewServerData?.course?.details?.name) ||
        (!state?.overViewDetails?.course?.details?.name &&
          !overviewServerData?.course?.details?.name) ? (
          <OverviewShimmmer />
        ) : (
          <>
            {" "}
            {isStandAlone ? (
              <>
                <StandAlone />
                <PricingSection
                  overviewServerData={overviewServerData}
                  getCourseCouponListStudentDataServer={
                    getCourseCouponListStudentDataServer
                  }
                  openModal={() => setIsModalOpen(true)}
                  multipleValidityData={multipleValidityData}
                  isStandAlone={isStandAlone}
                />
              </>
            ) : (
              <>
                {state?.overViewDetails?.course?.installments?.installmentAlert
                  ?.alertState === installmentsAlertStateEnum.COURSE_LOCKED ||
                overviewServerData?.course?.installments?.installmentAlert
                  ?.alertState === installmentsAlertStateEnum.COURSE_LOCKED ? (
                  <OverviewAlertBox isCourseLocked />
                ) : null}
                {paymentProcessingBox?.heading ? (
                  <OverviewAlertBox
                    isPaymentProcessing
                    onClick={() => refresh()}
                  />
                ) : null}
                {/* {write condition here for ispaymentprocessing} */}
                <OverView
                  overviewServerData={overviewServerData}
                  overViewClientData={state?.overViewDetails?.course}
                />
                {/* Multiple Validity */}
                {multipleValiditySelected && isPurchased === 0 && (
                  <>
                    <DashBorder sideMargins={16} inner />
                    <MultipleValidity openModal={() => setIsModalOpen(true)} />
                  </>
                )}
                <DashBorder sideMargins={16} inner />
                {Array.isArray(bundleData) && bundleData?.length > 0 ? (
                  <Bundle bundleData={bundleData} meta={courseMetaData} />
                ) : (
                  ""
                )}
                {state?.overViewDetails?.course?.metaData?.isPurchased ||
                state?.overViewDetails?.course?.installments
                  ?.purchasedViaInstallment ===
                  1 ? null : showCouponsEverywhere &&
                  multipleCouponsConditions < 3 ? (
                  <React.Fragment>
                    <DashBorder sideMargins={16} inner />
                    <Coupons
                      overviewServerData={overviewServerData}
                      getCourseCouponListStudentDataServer={
                        getCourseCouponListStudentDataServer
                      }
                    />
                  </React.Fragment>
                ) : null}

                {
                  isPurchased === 0 && addOnOptionId ?
                  (<MoneyBackGuarantee
                    prePurchaseAddOnAmount={prePurchaseAddOnAmount}
                    prePurchasePopUpEnabled={prePurchasePopUpEnabled}
                    addOnOptionId={addOnOptionId}
                    isRemoveButtonEnable={isRemoveButtonEnable}
                    data={genericData}
                  />):null
                }
                {
                  isPurchased === 1 && isMoneyBackClaimCard ?
                  (<MoneyBackClaimCard data={state}/>):null
                }
                <AboutCourse
                  overviewServerData={overviewServerData}
                  openModal={() => setIsModalOpen(true)}
                />
                <FreeContent overviewServerData={overviewServerData} />

                {!isModalOpenNew ? (
                  <UpcomingLive
                    heading="Live Classes"
                    headingColor="#fff"
                    viewAllText="View Full Schedule"
                    viewAllTextColor="#fff"
                    overViewHeadingBackgroundColor="#021927"
                    backgroundColor="#021927"
                    subText="Join live trial classes to learn more about the course"
                    subTextColor="#fff"
                    dotClasses="UpcomingLive__Body__Dots slick-dots"
                    zIndex={"2"}
                  />
                ) : null}
               {orgId !==1005023 && (
                <div ref={targetRef}>
                  <ChatComponent overviewServerData={overviewServerData} />
                </div>
               )}

                {(isPriceDetailsNewHidden == false || (isFreeCourse && isPurchased)) ? (
                  <PricingSection
                    overviewServerData={overviewServerData}
                    getCourseCouponListStudentDataServer={
                      getCourseCouponListStudentDataServer
                    }
                    openModal={() => setIsModalOpen(true)}
                  />
                ) : null}

              </>
            )}
            {
              isPurchased === 0 && addOnOptionId === 1 && isRemoveButtonEnable === false ?
              (<MoneyBackBottomDrawer
                prePurchaseAddOnAmount={prePurchaseAddOnAmount}
                prePurchasePopUpEnabled={prePurchasePopUpEnabled}
                addOnOptionId={addOnOptionId}
                data={genericData}
              />):null
            }
          </>
        )}
      </div>
    </>
  );
};

export default OverViewPage;
